module.exports = __webpack_public_path__ + "img/gift4.93d580d4.png";